/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Step_1Inputs */

const en_svc_integration_step_1 = /** @type {(inputs: Svc_Integration_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the systems, their APIs and the data that moves between them.`)
};

const lv_svc_integration_step_1 = /** @type {(inputs: Svc_Integration_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pārskatām sistēmas, to API un datus, kas starp tām pārvietojas.`)
};

/**
* | output |
* | --- |
* | "Review the systems, their APIs and the data that moves between them." |
*
* @param {Svc_Integration_Step_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_step_1 = /** @type {((inputs?: Svc_Integration_Step_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Step_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_step_1(inputs)
	return en_svc_integration_step_1(inputs)
});